import * as core from '../../../../../../../core'

import { query } from './value-of-change-by-functional-area.query'

export const RESOURCE = {
  payload: {
    alias: 'value.of.change.by.functional.area',
    description: 'Chart view of value of change by functional area',
    name: 'Value of Change by Functional Area',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
